<template>
  <section class="form-section">
    <div class="form-section__head">
      <h3>고객 정보</h3>
    </div>
    <div>
      <dl class="form-list__row form-list__row--text-only">
        <dt class="form-list__key">
          고객명
        </dt>
        <dd>
          <div>
            {{ orgCstmNm }}
          </div>
        </dd>
      </dl>
      <dl v-if="isForeigner && isPassYn !=='Y'" class="form-list__row">
                <div class="form-guide-text font-red">
          계좌입력이 안될 경우 PASS 인증을 진행 후 계좌 입력이 가능합니다
        </div>
        <div class="btn-wrap">
          <a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="certPass">PASS 인증</a>
        </div>
      </dl>
      <dl v-if="isForeigner && isPassYn ==='Y'" class="form-list__row">
        <div class="form-guide-text font-red">
          PASS 인증이 완료되었습니다. 계좌 입력이 가능합니다
        </div>
      </dl>
    </div>
  </section>
</template>

<script>
import DxTextBox from 'devextreme-vue/text-box'
import DxSelectBox from 'devextreme-vue/select-box'
import { DxCheckBox } from "devextreme-vue/check-box";

export default {
  name: 'NewBankHeader',
  components: {
    DxCheckBox,
    DxTextBox,
    DxSelectBox
  },
  props: [
    'isRegDone',
    'isPassYn',
    'isForeigner',
    'orgCstmNm',
    'temp_om_account',
    'bankCdList',
    'ordInfo'
  ],
  data: () => ({
    om_account_value: '',
    params: {
      cstmNm: '',
      bankCd: '',
      cstmAccnNum: null
    },
    cstmDpstNm: '',
    checkedSameName: false
  }),
  watch: {
    temp_om_account (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.om_account_value = this.temp_om_account
      }
    },
    om_account_value (newVal, oldVal) {
      if (newVal !== oldVal) {
        const regex = /[^0-9]/g
        const result = `${newVal}`.replace(regex, '')
        this.om_account_value = result
        this.params.cstmAccnNum = result
      }
    },
    params: {
      deep: true,
      handler (newVal) {
        this.$emit('changeBankInfo', newVal)
      }
    },
    ordInfo () {
      this.params.bankCd = this.ordInfo.bankCd
      this.params.cstmNm = this.ordInfo.cstmNm
      this.cstmDpstNm = this.ordInfo.cstmDpstNm
    }
  },
  created () {
    this.om_account_value = this.temp_om_account
    this.event_value = this.temp_event
    if (this.ordInfo) {
      this.params.bankCd = this.ordInfo.bankCd
      if (this.isRegDone) {
        this.params.cstmNm = this.ordInfo.cstmDpstNm
      }
    }
  },
  mounted () {
  },
  methods: {
    handleFocus (e) {
      const trgtHeight = e.element.offsetHeight + 90
      window.scrollTo(0, trgtHeight)
    },
    handleFocusOut (e) {
    },
    certPass (e) {
      this.$emit('certPass')
    },
    handleSelectBoxClick (isOpened) {
      if (isOpened) {
        document.body.id = 'TalkDeposit'
        return
      }
      if (!isOpened && document.body.id === 'TalkDeposit') {
        document.body.id = ''
      }
    },
    handleCheckedSameName(e){
      const { value, event } = e;
      if(value){
        this.params.cstmNm = this.orgCstmNm;
      }
    }
  }
}
</script>

<style scoped>
  .div-checkedSameName{
    width : 100px;
  }

  @media only screen and (max-width: 1260px){
    .div-checkedSameName {
      text-align : right; 
      float : right;
    }
  }
  
  .re-style .form-section {
    margin-bottom: 15px;
    padding: 0;
}

</style>


// WEBPACK FOOTER //
// src/views/purchase/sale/components/NewBankHeader.vue